module.exports = __webpack_public_path__ + "media/images/cloud-mlx-badge-tiny-0a5b9395.svg";